import qs from 'qs';

import uniqBy from 'lodash/uniqBy';

const groupsToFilterRelation = {
	'affiliate': {
		name: 'affiliates',
		id: 'affiliate_id'
	},
	'manager': {
		name: 'managers',
		id: 'manager_id'
	},
	'offer': {
		name: 'offers',
		id: 'offer_id'
	},
	'country': {
		name: 'countries',
		id: 'country_id'
	},
	'sale_model': {
		name: 'sale_model',
		id: 'sale_model_id'
	}
};

const queryToState = (state, data) => {
	const entity = getEntity(state, data);
	const query = getQuery(entity);

	return qs.stringify({ query, entity });
};

export default queryToState;

function getEntity(state, data) {
	const groups = state.grouping.values;

	const selectedFilters = state.filters.selectedFilters && (
		state.filters.selectedFilters
			.map(entity => ({
				name: entity.name,
				values: entity.value
			}))
			.filter(entity => entity.values.length)
	);

	const fromGroupFilters = groups.map(entity => {
		const meta = groupsToFilterRelation[entity.value];
		const firstRowData = data.rows[0];
		const label = firstRowData[entity.value] || null;
		const value = firstRowData[meta.id] || null;

		return {
			name: meta.name,
			values: [{
				label,
				value
			}]
		};
	});

	const filters = uniqBy([].concat(selectedFilters, fromGroupFilters), 'name');

	return {
		date_range: state.query.date_range,
		currency: state.query.currency,
		filters
	};
}

function getQuery(entity) {
	return {
		groups: ['date'],
		date_range: entity.date_range,
		currency: entity.currency,
		filters: entity.filters.reduce((acc, filter) => {
			acc[filter.name] = filter.values.map(val => val.value);
			return acc;
		}, {})
	};
}


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/affiliates-activity/utils/query-to-stat.js